import { createFileRoute } from '@tanstack/react-router'
import Breadcrumb from "@/components/Breadcrumb";
import en from "../../i18n/locales/en.json";
import { useI18n } from "../../i18n/context";

export const Route = createFileRoute('/$locale/privacy-policy')({
  component: PrivacyPolicy,
})

function PrivacyPolicy() {
  const { t } = useI18n();
  const pp = (en.footer && (en.footer.privacyPolicy as any)) || {};
  const s = (pp && pp.sections) || {};
  const title = pp.title || 'Privacy Policy';
  const effectiveDate = pp.effectiveDate || 'Effective date: 2026-09-08';
  const copy = pp.copyright || `© ByteOne (UK) LTD. All rights reserved.`;
  return (
    <>
      <main className="main-content" style={{ paddingTop: '8px' }}>
        <Breadcrumb text1="Home" text2={title} />
        <div className="container-fluid collections-container">
          <div className="col-12 py-0">
            <div className="pixel-card mt-2" style={{ padding: '24px 16px', borderRadius: '12px' }}>
              <h1 className="h4 text-white mb-3">{title}</h1>
              <p className="text-secondary small mb-2">{effectiveDate}</p>
              {(s.dataWeCollect||s[Object.keys(s)[0]]) && (
                <>
                  <h5 className="text-white mt-3 mb-2">{s.dataWeCollect?.heading || Object.keys(s)[0]}</h5>
                  <p className="text-secondary small">{s.dataWeCollect?.body || ''}</p>
                </>
              )}
              {s.useOfData && (
                <>
                  <h5 className="text-white mt-3 mb-2">{s.useOfData.heading}</h5>
                  <p className="text-secondary small">{s.useOfData.body}</p>
                </>
              )}
              {s.cookies && (
                <>
                  <h5 className="text-white mt-3 mb-2">{s.cookies.heading}</h5>
                  <p className="text-secondary small">{s.cookies.body}</p>
                </>
              )}
              {s.thirdParties && (
                <>
                  <h5 className="text-white mt-3 mb-2">{s.thirdParties.heading}</h5>
                  <p className="text-secondary small">{s.thirdParties.body}</p>
                </>
              )}
              {s.yourRights && (
                <>
                  <h5 className="text-white mt-3 mb-2">{s.yourRights.heading}</h5>
                  <p className="text-secondary small">{s.yourRights.body}</p>
                </>
              )}
              {s.changes && (
                <>
                  <h5 className="text-white mt-3 mb-2">{s.changes.heading}</h5>
                  <p className="text-secondary small">{s.changes.body}</p>
                </>
              )}
              <p className="text-secondary small mt-3 mb-0">{copy}</p>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}
